import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import EmbeddedBackButton from 'features/EmbeddedBackButton';

let containerRef:
  | React.MutableRefObject<HTMLDivElement | null>
  | undefined = undefined;

export const EmbeddedBackButtonContainer = () => {
  containerRef = useRef<HTMLDivElement | null>(null);
  return <div ref={containerRef} id="embeddedBackButton"></div>;
};

const ApplicationLayout: React.FC = ({ children }) => {
  const container = containerRef ? containerRef.current : null;

  return (
    <div>
      {container && ReactDOM.createPortal(<EmbeddedBackButton />, container)}
      {children}
    </div>
  );
};

export default ApplicationLayout;
